"use client";

import { z } from "zod";

// **Schema para login**
export const SignInSchema = z.object({
  email: z.string().email("E-mail inválido."),
  password: z.string().min(1, "A senha deve ter pelo menos 1 caractere."),
});

// **Schema para criação de conta**
export const SignUpSchema = z.object({
  instance: z.string().min(1, "Instância é obrigatória"),
  name: z.string().min(1, "Nome é obrigatório"),
  email: z.string().email("E-mail inválido."),
  password: z.string().min(6, "A senha deve ter pelo menos 6 caracteres"),
  phone: z.string().min(10, "Número de telefone inválido").optional(),
  file_uuid: z.string().optional(),
});

// **Schema para recuperação de senha**
export const RecoverPasswordSchema = z.object({
  email: z.string().email("E-mail inválido."),
});

// **Schema para seleção de instância**
export const SelectInstanceSchema = z.object({
  instance: z.string().min(1, "Instância é obrigatória"),
});

// **Schema para confirmação de email**
export const ConfirmEmailSchema = z.object({
  token: z.string().min(1, "Token é obrigatório"),
});

// **Schema de resposta para login**
export const SignInResponseSchema = z.object({
  status: z.string(),
  statusCode: z.number(),
  message: z.array(z.string()),
  data: z.object({
    access_token: z.string(),
    refresh_token: z.string(),
  }),
});
